import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const storage = createJSONStorage<Record<string, boolean>>(() => localStorage);
const columnVisibilityAtom = atomWithStorage<Record<string, boolean>>(
	`columnVisibilities`,
	{},
	storage,
	{
		getOnInit: true,
	}
);

export default columnVisibilityAtom;
